import BaseService from './BaseService'

const PRODUCT_ID = 'CONVERSATIONS_AI'

class ConversationAiResellingService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  getProductConfiguration = () =>
    this.requests.get(`/product?productCode=${PRODUCT_ID}`)

  getCompanyResellingConfig = (companyId: string) =>
    this.requests.get(`/configuration/company/${companyId}/${PRODUCT_ID}`)

  updateCompanyResellingConfig = (
    companyId: string,
    data: { amount?: number; offeringEnabled?: boolean }
  ) =>
    this.requests.put(`/configuration/company/${companyId}/${PRODUCT_ID}`, data)

  getLocationConfig = (locationId: string) =>
    this.requests.get(`/configuration/location/${locationId}/${PRODUCT_ID}`)

  getLocationSubscriptions = (locationId: string) =>
    this.requests.get(`/subscription/location/${locationId}`)

  updateLocationResellingConfig = (
    locationId: string,
    data: { amount?: number; offeringEnabled?: boolean }
  ) =>
    this.requests.put(`/configuration/location/${locationId}/${PRODUCT_ID}`, data)

  agencyDirectPurchase = (locationId: string) =>
    this.requests.post(`/subscription/location/${locationId}/${PRODUCT_ID}`, {
      purchaseStyle: 'COMPANY_DIRECT_PURCHASE',
    })

    getCompanySubscriptions = (companyId: string) =>
    this.requests.get(`/subscription/company/${companyId}`)
}

const instance = new ConversationAiResellingService(
  BaseService.servicesConfig.Reselling
)

export default instance
